






















import { BookComponents } from '../components'
import { bookModelProvider } from '../model'
import { defineClassComponent } from '@/hooks'

export default defineClassComponent(
  {
    components: BookComponents,
  },
  () =>
    class {
      bookModel = bookModelProvider.inject()
    },
)
